import { useLayoutEffect, useState } from 'react'

const DEFEULT_WIDTH = 1440
const DEFEULT_HEIGHT = 900

function useWindowSize() {
  const [size, setSize] = useState([window?.innerWidth ?? DEFEULT_WIDTH, window?.innerHeight ?? DEFEULT_HEIGHT])

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size
}

export default useWindowSize
